import { Link } from "gatsby"
import React from "react"
// import { graphql } from "gatsby"
// import '../reset.css';
// import styled from 'styled-components';
// import { get, minBy, mapValues } from 'lodash'

// const Container = styled.div`
//   padding:20px;
//   display:flex;
// `;
// const LargeMenus = styled.div`

// `;

// const Contents = styled.div`

// `;
import styled, { createGlobalStyle } from 'styled-components'
const GlobalStyle = createGlobalStyle`
html,body, #___gatsby, #gatsby-focus-wrapper{
    height:100%;
}
a{
    text-decoration:none;
    color:#4c4c4c;
}
`

const LinkItem = styled.div`
    margin-top:20px;
    font-size:20px;
`;

export default function Home() {
    return <>
        <GlobalStyle />
        <div style={{ display: "table", height: "100%", width: "100%", textAlign: "center" }}>
            <div style={{ display: "table-cell", verticalAlign: "middle" }}>
                <h1>웹웍스 메뉴얼 페이지</h1>
                
                <LinkItem>
                    <Link to="/doc/editor/editor1">에디터 가이드</Link>
                </LinkItem>

                <LinkItem>
                    <Link to="/doc/reservation/creator">예약 시스템 가이드</Link>
                </LinkItem>

                <LinkItem>
                    <Link to="/doc/shop/creator">쇼핑몰 가이드</Link>
                </LinkItem>
            </div>
        </div>
    </>
}
// export default function Home(props) {
//   const { data } = props;

//   let docMenus = get(data, "allMarkdownRemark.edges");

//   docMenus = mapValues(
//     docMenus.reduce((acc, menu) => {
//       const parentName = menu.node.frontmatter.parent;
//       acc[parentName] = (acc[parentName] || []).concat(menu.node.frontmatter);
//       return acc;
//     }, {})
//     ,
//     menus => {
//       return minBy(menus, "order");
//     }
//   );

//   docMenus = Object.keys(docMenus).map(key => {
//     const menu = docMenus[key];
//     return {
//       label: ({
//         "editor": "에디터",
//         "reservation": "예약",
//       }[key] || "분류없음"),
//       path: menu.path
//     }
//   });

//   return <Container>
//     <LargeMenus>
//       {
//         docMenus.map((menu) => {
//           // console.log(menu);
//           return <div key={menu.path}>
//             <a href={menu.path}>
//               {menu.label}
//             </a>
//           </div>
//         })
//       }
//     </LargeMenus>
//     <Contents>
//     </Contents>
//   </Container>
// }

// export const query = graphql`
//   query {
//     allMarkdownRemark(filter: {frontmatter: {parent: {ne: null}}}) {
//       edges {
//         node {
//           id
//           frontmatter {
//             order
//             title
//             parent,
//             path
//           }
//         }
//       }
//     }
//   }
// `